import axios from 'axios/index';
import { API_REGIX } from '../../utils/constants';

const regixCheck = async (userToken, hash) => { // queries === object

    return await axios.get(API_REGIX(userToken), {
        headers: {
            "Accept": "application/json",
            "Accept-language": "bg",
            "Authorization": hash,
        }
    }).then(resp => {
        return resp.data;
    }).catch(err => {
        console.error(err)
    })

}

export default regixCheck;